var exports = {
  "$": "commandDetail__sW8zNj",
};

module.exports = exports;
